// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/report_attributes/lista
 *
 * Returns the full list of active report attributes. Legacy `dados`
 * shape is a list, so getDados() returns the array directly.
 */
import type { Report_attributes_AttributeRow } from './Report_attributes_AttributeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Report_attributes_ListaResponseDados = Report_attributes_AttributeRow[];

export type Report_attributes_ListaResponse = ApiResponse<Report_attributes_ListaResponseDados>;

registerResponseContract('Report_attributes_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_ra_id:         { type: 'number',  required: true },
      so_ra_name:       { type: 'string',  required: true },
      so_ra_type:       { type: 'string',  required: true },
      so_ra_active:     { type: 'number',  required: true },
      so_ra_created_at: { type: 'string',  required: true },
    },
  },
})
